import type { WorkItem } from "../types/work";

export type ArchiveCategory = {
  id: string;
  label: string;
  caption: string;
  blurb: string;
  /** Empty for the product design tab, which renders Figma case studies instead. */
  items: WorkItem[];
};

/**
 * Archive films, supplied as Vimeo links. Titles, poster frames, and playback
 * shape are read from each film itself at runtime, so nothing here is invented.
 */
function toItems(prefix: string, tags: string[], ids: string[]): WorkItem[] {
  return ids.map((vimeoId, index) => ({
    id: `${prefix}-${vimeoId}`,
    index: String(index + 1).padStart(3, "0"),
    vimeoId,
    tags,
  }));
}

const motionIds = [
  "1214643167", "1214777791", "1215748705", "1220450526", "1220451191",
  "1220435552", "1213608264", "1215511396", "1178003422", "1214517898",
  "1220557699", "1220558513", "1220558834", "1220560890", "1214517044",
  "1216338100", "1177997028", "553670494", "816467839",
  "1220599491", "1220599554", "1220601235", "1220601370",
  "1220623697",
];

const editIds = [
  "1213219566", "816425306", "1177991734", "1220561592", "1220551021",
  "1220562470", "1220562689", "1213857334", "1220563515", "1220563642",
  "1220594013", "1220594505", "1220595599", "1220602220",
  "1220625508",
];

export const archiveCategories: ArchiveCategory[] = [
  {
    id: "motion",
    label: "Motion Design & Animation",
    caption: "2D / 3D / Motion / CGI / VFX & Compositing",
    blurb: "Animation, CGI and compositing work across commercial, broadcast and social delivery.",
    items: toItems("motion", ["MOTION", "CGI", "VFX"], motionIds),
  },
  {
    id: "edit",
    label: "Video Editing & Post-Production",
    caption: "Edit / Post / Delivery",
    blurb: "Edits, finishing and platform delivery for films, campaigns and long-form content.",
    items: toItems("edit", ["EDIT", "POST", "DELIVERY"], editIds),
  },
  {
    id: "product",
    label: "UI UX / Product Design",
    caption: "Flows / Interfaces / Systems",
    blurb: "Interface and product design carrying the same craft as the film work. Each case opens its frames in Figma.",
    items: [],
  },
];
